<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qwj6Sq/tc-custom/1.png?1614903923636?1705766048163" alt="This image is the cover for the book Molly, the Unicorn and the Hare"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Molly, the Unicorn and the Hare
      </h1>
      <p class="bookDescription body article font2">
        <p>This lovely fantasy tale takes a young girl called Molly, who has just turned 10, on an exciting and sometimes scary journey into the Otherworld. Aided by an enchanted painting, an ancient and magical clock that is able to control time and a shapeshifting brown hare, Molly travels through space and time to meet a fabulous unicorn who will change her life forever. The unicorn introduces Molly to a world populated by legendary and mythical creatures long forgotten by all but a handful of humans. She learns that a dark force which has been causing trouble in the human world is now spreading into the Otherworld and must be stopped from doing more harm. Molly discovers that she has supernatural powers and will become the person able to help the unicorn and other creatures defeat the threat. Before she can do so, she must learn much more about herself and how to harness the powers of the Otherworld.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Lund-Lack
      </h2>
      
      <p class="authorDescription body article">Originally from Devon, the author spent his early years from 1956 in Hong Kong and New Zealand, returning to the UK in 1969. He is married to Amanda and has three children, who are now all married with families of their own. Following an eventful career in the Metropolitan Police, he retired to Suffolk, where he continued to develop his career as an artist. In addition to painting, he has turned his hand to writing and used his imagination and skills as an artist to illustrate Molly, the Unicorn and the Hare. The book was inspired by a painting of a unicorn that he gave to his eldest granddaughter on her eighth birthday.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3564143a